import BuyerWorkspace from "components/Marketing/BuyerWorkspace";
import CropProfilesWorkspace from "components/Marketing/CropProfilesWorkspace";
import PositionSummaryReportPane from "components/Marketing/PositionSummaryReportPane";
import SalesWorkspace from "components/Marketing/SalesWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const marketingRoutes = [
  {
    path: "/marketing/sales/",
    element: <RouteLayout />,
    children: [{ index: true, element: <SalesWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Sales" />,
  },
  {
    path: "/marketing/crop_profiles/",
    element: <RouteLayout />,
    children: [{ index: true, element: <CropProfilesWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Crop Profiles" />,
  },
  {
    path: "/marketing/position_summary",
    element: <RouteLayout />,
    children: [{ index: true, element: <PositionSummaryReportPane /> }],
    errorElement: <RouteErrorLayout errorTitle="Position Summary" />,
  },
  {
    path: "/marketing/buyers/",
    element: <RouteLayout />,
    children: [{ index: true, element: <BuyerWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Buyers" />,
  },
  {
    path: "/marketing/position_summary/:producer_token/:defaultYear",
    element: <RouteLayout />,
    children: [{ index: true, element: <PositionSummaryReportPane /> }],
    errorElement: <RouteErrorLayout errorTitle="Position Summary" />,
  },
  {
    path: "/marketing/position_summary/:producer_token/:defaultYear/:default_commodity_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <PositionSummaryReportPane /> }],
    errorElement: <RouteErrorLayout errorTitle="Position Summary" />,
  },
  {
    path: "/marketing/sales/:producer_token/:defaultYear/:default_commodity_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <PositionSummaryReportPane /> }],
    errorElement: <RouteErrorLayout errorTitle="Position Summary" />,
  },
];
